// API Service for MOS Veteran
// Centralizes all backend API calls

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Process donation through Stripe (MOCKED - will be replaced with real Stripe integration)
 * @param {Object} donationData - Donation details
 * @returns {Promise<Object>} Response from server
 */
export const processDonation = async (donationData) => {
  try {
    const response = await fetch(`${API_URL}/api/donate`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(donationData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error processing donation:', error);
    return {
      success: false,
      message: 'Unable to process donation. Please try again later.',
    };
  }
};

/**
 * Subscribe to newsletter via Mailchimp (MOCKED - will be replaced with real Mailchimp integration)
 * @param {string} email - Email address
 * @returns {Promise<Object>} Response from server
 */
export const subscribeNewsletter = async (email) => {
  try {
    const response = await fetch(`${API_URL}/api/newsletter`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error subscribing to newsletter:', error);
    return {
      success: false,
      message: 'Unable to subscribe. Please try again later.',
    };
  }
};

/**
 * Submit contact form (MOCKED - will be replaced with real email service)
 * @param {Object} contactData - Contact form data
 * @returns {Promise<Object>} Response from server
 */
export const submitContactForm = async (contactData) => {
  try {
    const response = await fetch(`${API_URL}/api/contact`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(contactData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error submitting contact form:', error);
    return {
      success: false,
      message: 'Unable to send message. Please try again later.',
    };
  }
};

/**
 * Submit enrollment form (MOCKED - will be replaced with real email service)
 * @param {Object} enrollmentData - Enrollment form data
 * @returns {Promise<Object>} Response from server
 */
export const submitEnrollmentForm = async (enrollmentData) => {
  try {
    const response = await fetch(`${API_URL}/api/enroll`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(enrollmentData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error submitting enrollment form:', error);
    return {
      success: false,
      message: 'Unable to submit application. Please try again later.',
    };
  }
};
